import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField, TextAreaField } from "components";
import { apiPost } from "api/callApi";
import { useLocation } from "react-router";
import { showAlert } from "utils/helper";

function SupportComponent(props) {
  const {
    setOpenModalView,
    setIsEditing,
    openModalView,
    fieldData,
    setFieldData = () => {},
    reloadData,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(fieldData || {});

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };
  const handleSubmit = async () => {
    setLoading(true);
    if (
      data.message == "" ||
      data.subject == "" ||
      !data.message ||
      !data.subject
    ) {
      showAlert({
        title: "Error",
        text: "Please fill all the fields",
        icon: "error",
      });
      return;
    }
    try {
      const payload = {
        message: data.message,
        subject: data.subject,
      };
      const response = await apiPost(`/v1/support`, payload, false);

      showAlert({
        title: "Success",
        text: response.message || "Support Request sent successfully",
        icon: "success",
      });
      setOpenModalView(false);
      setLoading(false);
    } catch (error) {
      console.log(error);

      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });
    }
  };

  const handleCancelCompanyModal = () => {
    setOpenModalView(false);
    setData({});
    if (typeof setFieldData === "function") {
      setFieldData(null);
    }
  };

  const { pathname } = useLocation();
  const paddingValue = pathname === "/" ? "0px" : "10px";
  const AddModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <Label label={"Subject"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <InputField
                name="subject"
                value={data.subject}
                onChange={handleChange}
                required
                style={{ width: "100%" }}
                // capitalize
              />
            </div>
          </Label>
          <Label label={"Message"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <TextAreaField
                type="textarea"
                name="message"
                value={data.message}
                onChange={handleChange}
                required
                style={{ width: "100%" }}
                // capitalize
              />
            </div>
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelCompanyModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Submit"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          // padding={paddingValue}
          title={"Support"}
          openModal={openModalView}
          renderBodyConditionally={AddModalData}
          handleCloseModal={() => {
            setOpenModalView(false);
            setData("");
          }}
        />
      )}
    </>
  );
}

export default SupportComponent;
